import React from 'react';
import { useKbConfluenceContext as useKbConfluenceContextDI } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/kb-confluence-context/index.tsx';
import { usePageContext as usePageContextDI } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/page-context/main.tsx';
import messages from './messages';
import { NotLinkConfluenceMessage } from './no-confluence-message';

type Props = {
	baseUrl: string;
	usePageContext?: typeof usePageContextDI;
	useKbConfluenceContext?: typeof useKbConfluenceContextDI;
};

const Banner = ({
	baseUrl,
	usePageContext = usePageContextDI,
	useKbConfluenceContext = useKbConfluenceContextDI,
}: Props) => {
	const [{ data: pageContextData }] = usePageContext();
	const { projectContext } = pageContextData || {};
	const { projectKey, isAdmin } = projectContext || {};
	const [{ data: confluenceLink, error: confluenceLinkError, loading }] =
		useKbConfluenceContext(projectKey);

	if (loading) {
		return null;
	}

	const noConfMsgProps = {
		settingMessage: messages.linkToConfluenceSetting,
		warningIconLabel: messages.warningIconLabel,
		isAdmin,
		baseUrl,
		projectKey,
	};

	if (confluenceLinkError) {
		return (
			// @ts-expect-error - TS2322 - Type '{ errorMessage: MessageDescriptorV2; settingMessage: MessageDescriptorV2; warningIconLabel: MessageDescriptorV2; isAdmin: boolean | undefined; useIntl: () => IntlShapeV2; baseUrl: string; projectKey: string | undefined; }' is not assignable to type 'Props'.
			<NotLinkConfluenceMessage {...noConfMsgProps} errorMessage={messages.linkNotSupportedJsm} />
		);
	}

	if (!confluenceLink) {
		return (
			// @ts-expect-error - TS2322 - Type '{ errorMessage: MessageDescriptorV2; settingMessage: MessageDescriptorV2; warningIconLabel: MessageDescriptorV2; isAdmin: boolean | undefined; useIntl: () => IntlShapeV2; baseUrl: string; projectKey: string | undefined; }' is not assignable to type 'Props'.
			<NotLinkConfluenceMessage {...noConfMsgProps} errorMessage={messages.linkNotAvailableJsm} />
		);
	}

	return null;
};

export { Banner };
